// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-67bcee96] .modal-container{display:flex;height:100%}", "",{"version":3,"sources":["webpack://./src/Registration.vue"],"names":[],"mappings":"AACA,mCACC,YAAA,CACA,WAAA","sourcesContent":["\n::v-deep .modal-container {\n\tdisplay: flex;\n\theight: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
